import { render, staticRenderFns } from "./PhotoOwnerGrid.vue?vue&type=template&id=0f83a4f3"
import script from "./PhotoOwnerGrid.vue?vue&type=script&lang=js"
export * from "./PhotoOwnerGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports